<script setup>
const { t } = useI18n()
const markets = [
  {
    name: 'australia',
    url: 'https://www.michaelhill.com.au',
  },
  {
    name: 'newZealand',
    url: 'https://www.michaelhill.co.nz',
  },
  {
    name: 'canada',
    url: 'https://www.michaelhill.ca',
  },
]

function trackClick(e, { name, url }) {
  pushEventToDataLayer('custom.menu.link', {
    group: 'footer',
    type: 'AppFooter:BaseLink',
    label: t(`footer.regional_sites_links.${name}`),
    info: {
      url,
      element: e?.target?.tagName,
      location: 'footer',
    },
  })
}
</script>

<template>
  <div class="footer__disclaimer">
    <div class="footer__disclaimer-copyrights">
      <div class="text-xxs">{{ $t('footer.copyrights', { date: new Date().getFullYear() }) }}</div>
      <div class="footer__disclaimer-sites">
        <template v-for="(market, i) in markets" :key="market.name">
          <a
            :href="market.url"
            target="_self"
            class="footer__disclaimer-sites-link"
            @click="trackClick($event, market)"
          >
            {{ $t(`footer.regional_sites_links.${market.name}`) }}
          </a>
          <span v-if="i < markets.length - 1">•</span>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.footer__disclaimer {
  font-size: var(--text-xsmall);
  display: flex;
  flex-direction: column;
  gap: var(--space-50);
  margin: 0;

  @media (--desktop) {
    grid-area: left;
    max-width: 36rem;
  }

  .footer__disclaimer-copyrights {
    display: flex;
    flex-direction: column;
    gap: var(--space-20);

    .footer__disclaimer-sites {
      display: flex;
      gap: var(--space-20);

      & a {
        text-decoration: none;
      }
    }
  }
}
</style>
